/* SDC PDP – nedräkning, galleri, paketväljare, karuseller, video */
(function () {
  if (window.__sdcLoaded) return;
  window.__sdcLoaded = true;
  function once(el) { if (el.__sdcReady) return false; el.__sdcReady = true; return true; }
  function pad(n) { return String(n).padStart(2, '0'); }

  // Evergreen-nedräkning: räknar ner till nästa hela intervall (timmar) och börjar om
  function initCountdowns() {
    document.querySelectorAll('[data-sdc-countdown]').forEach(function (el) {
      if (!once(el)) return;
      var hours = parseFloat(el.dataset.hours || '2');
      var span = hours * 3600 * 1000;
      var key = 'sdc-cd-' + (el.dataset.key || 'default');
      var end;
      try { end = parseInt(localStorage.getItem(key), 10); } catch (e) {}
      if (!end || end < Date.now()) {
        end = Date.now() + span;
        try { localStorage.setItem(key, end); } catch (e) {}
      }
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      if (!h) return;
      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          end = Date.now() + span;
          try { localStorage.setItem(key, end); } catch (e) {}
          left = span;
        }
        h.textContent = pad(Math.floor(left / 3600000));
        m.textContent = pad(Math.floor(left / 60000) % 60);
        s.textContent = pad(Math.floor(left / 1000) % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function initGalleries() {
    document.querySelectorAll('[data-sdc-gallery]').forEach(function (g) {
      if (!once(g)) return;
      var main = g.querySelector('[data-main]');
      g.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          main.src = t.dataset.full;
          main.srcset = '';
        });
      });
    });
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function initSelectors() {
    document.querySelectorAll('[data-sdc-selector]').forEach(function (root) {
      if (!once(root)) return;
      var fmt = root.dataset.moneyFormat;
      var cards = root.querySelectorAll('[data-bundle]');
      var btn = root.querySelector('[data-atc]');
      var priceNow = root.querySelector('[data-atc-price]');
      var priceWas = root.querySelector('[data-atc-compare]');
      var gifts = root.querySelectorAll('[data-gift-tier]');

      function select(card) {
        cards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        card.querySelector('input').checked = true;
        priceNow.textContent = money(+card.dataset.price, fmt);
        priceWas.textContent = card.dataset.compare > 0 ? money(+card.dataset.compare, fmt) : '';
        var tier = +card.dataset.tier;
        gifts.forEach(function (g) { g.classList.toggle('is-locked', +g.dataset.giftTier > tier); });
        root.querySelectorAll('[data-vs-tier]').forEach(function (v) { v.hidden = +v.dataset.vsTier > tier; });
      }
      cards.forEach(function (c) { c.addEventListener('click', function () { select(c); }); });
      var oneBtn = root.querySelector('[data-onetime]'), subNotes = root.querySelector('[data-sub-notes]');
      if (oneBtn) oneBtn.addEventListener('click', function () {
        var on = root.classList.toggle('is-onetime');
        oneBtn.textContent = on ? oneBtn.dataset.off : oneBtn.dataset.on;
        if (subNotes) subNotes.style.display = on ? 'none' : '';
      });
      var initial = root.querySelector('[data-bundle].is-selected') || cards[0];
      if (initial) select(initial);

      btn.addEventListener('click', function () {
        var card = root.querySelector('[data-bundle].is-selected');
        if (!card) return;
        btn.disabled = true;
        var onetime = root.classList.contains('is-onetime');
        var item = { id: +card.dataset.variant, quantity: +card.dataset.qty };
        if (card.dataset.plan && !onetime) item.selling_plan = +card.dataset.plan;
        var items = [item];
        if (card.dataset.gifts && !onetime) card.dataset.gifts.split(',').forEach(function (g) { g = g.trim(); if (g) items.push({ id: +g, quantity: 1, properties: { _gift: 'Free gift' } }); });
        var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        var dest = root.dataset.redirect || '/checkout';
        var toCheckout = /checkout/.test(dest);
        // Direkt till kassan: töm varukorgen först så kunden bara betalar för paketet hen nyss valde
        (toCheckout ? fetch(base + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }) : Promise.resolve()).then(function () {
          return fetch(base + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          if (toCheckout && window.ltResvCode) dest += (dest.indexOf('?') > -1 ? '&' : '?') + 'discount=' + encodeURIComponent(window.ltResvCode);
          window.location.href = dest;
        }).catch(function () {
          btn.disabled = false;
          alert('Something went wrong. Please try again.');
        });
      });
    });
  }

  function initCarousels() {
    document.querySelectorAll('[data-sdc-carousel]').forEach(function (c) {
      if (!once(c)) return;
      var track = c.querySelector('[data-track]');
      var dots = c.querySelectorAll('[data-dots] span');
      function step() { var first = track.children[0]; return first ? first.getBoundingClientRect().width + 10 : 300; }
      var prev = c.querySelector('[data-prev]'), next = c.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (dots.length) {
        track.addEventListener('scroll', function () {
          var max = track.scrollWidth - track.clientWidth;
          var i = max > 0 ? Math.round(track.scrollLeft / max * (dots.length - 1)) : 0;
          dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
        }, { passive: true });
      }
    });
  }

  function initVideos() {
    document.querySelectorAll('.sdc-vid video').forEach(function (v) {
      if (!once(v)) return;
      v.parentElement.addEventListener('click', function () {
        if (v.paused) { v.muted = false; v.play(); v.parentElement.classList.add('is-playing'); }
        else { v.pause(); v.parentElement.classList.remove('is-playing'); }
      });
    });
  }

  function init() { initCountdowns(); initGalleries(); initSelectors(); initCarousels(); initVideos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
